import React from 'react';

export default function TintSunglassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="30.94,25.43 2.0,25.43 2.0,14.57 30.94,14.57" fill="#A5A5A5" />
      <polygon points="30.94,25.43 2.0,25.43 2.0,14.57 30.94,14.57" fill="#A5A5A5" />
      <polygon points="9.06,23.53 2.0,20.0 2.0,14.57 9.06,18.1" fill="#727272" opacity="0.95" />
      <polygon points="38.0,23.53 30.94,20.0 30.94,14.57 38.0,18.1" fill="#727272" opacity="0.95" />
    </svg>
  );
}
